import classnames from "classnames";
import moment from "moment-timezone";
import PropTypes from "prop-types";
import React from "react";

import {TIME_FORMAT} from "config/constants";
import {Destination} from "v2/api/Records";
import DestinationEstStartTime from "v2/components/DestinationEstStartTime";
import {durationToUnits} from "utils";

const DestinationTimings = (props) => {
  const {
    data,
    data: {
      checkinTime,
      checkoutTime,
      duration,
      estEndTime,
    },
  } = props;

  let actualContent;
  if (checkinTime) {
    if (checkoutTime) {
      const actualDuration = moment.duration(
        checkoutTime.diff(checkinTime, "milliseconds"));
      const diffMins = Math.ceil(moment.duration(
        actualDuration.asMilliseconds() - duration.asMilliseconds()).asMinutes());
      const diffClassName = classnames("erg-margin-left-15", {
        "text-muted": diffMins === 0,
        "text-success": diffMins < 0,
        "text-warning": diffMins > 0,
      });

      actualContent = (
        <div className="erg-info-row">
          <label className="erg-info-label">Actual:</label>
          <label className="erg-info-value">
            <strong>{checkinTime.format(TIME_FORMAT)}</strong>
            {" to "}
            <strong>{checkoutTime.format(TIME_FORMAT)}</strong>
            <span className="erg-margin-left-15">
              ({durationToUnits(actualDuration, "minutes")} min)
            </span>
            <span className={diffClassName}>
              {diffMins > 0 && "+"}{diffMins} min
            </span>
          </label>
        </div>
      );
    } else {
      actualContent = (
        <div className="erg-info-row">
          <label className="erg-info-label">Checkin:</label>
          <label className="erg-info-value">
            <strong>{checkinTime.format(TIME_FORMAT)}</strong>
          </label>
        </div>
      );
    }
  }

  return (
    <div className="DestinationTimings erg-info-block">
      <div className="erg-info-row">
        <label className="erg-info-label">Planned:</label>
        <label className="erg-info-value">
          <DestinationEstStartTime data={data} />
          {" to "}
          <strong>{estEndTime.format(TIME_FORMAT)}</strong>
          <span className="erg-margin-left-15">
            ({durationToUnits(duration, "minutes")} min)
          </span>
        </label>
      </div>
      {actualContent}
    </div>
  );
};

DestinationTimings.propTypes = {
  data: PropTypes.instanceOf(Destination).isRequired,
};

export default DestinationTimings;



/** WEBPACK FOOTER **
 ** ./src/app/v2/components/DestinationTimings.js
 **/